import { LoggedLayout } from "../layout/LoggedLayout.tsx";
import { Home } from "../components/Home.jsx";

function LoggedHome (){
    return (
        <LoggedLayout>
            <Home/>
        </LoggedLayout>
    )
}

export {LoggedHome};